import { DownloadContext } from "@/App"
import { Button, message, Modal, Progress } from "antd"
import { useCallback, useContext, useEffect, useState } from "react"
import DragModal from "@/baseui/drag-modal/DragModal"
import DownloadItem from "./download-item"
import './index.less'

export interface DownloadState {
    files: DownloadFile[]
    visible: boolean
    startDownload: (file: DownloadFile[], onCloseCallbackFn?: () => void) => void
    startExtraDownload: (file: DownloadFile[]) => void
    onEnd: () => void
}

export interface DownloadFile {
    objectName: string
    bucketName: string
    filename: string
    suffix: string
    url?: string
    md5?: string
}

export const useDownloadService = () => {
    const [files, setFiles] = useState<DownloadFile[]>(null);
    const [visible, setVisible] = useState<boolean>(false);
    const [onCloseCallbackFn, setOnCloseCallbackFn] = useState<() => void>();
    const startDownload = useCallback((dfile: DownloadFile[], onCloseCallbackFn) => {
        setFiles([...dfile])
        setOnCloseCallbackFn(onCloseCallbackFn);
    }, [])

    const startExtraDownload = useCallback((dfile: DownloadFile[]) => {
        setFiles(pre => {
            if (pre == null || pre.length === 0) {
                return [...dfile]
            }
            return [...pre, ...dfile];
        })
    }, [files])

    const onEnd = useCallback(() => {
        setVisible(false);
        setFiles([]);
        if (!!onCloseCallbackFn) {
            onCloseCallbackFn();
        }
    }, [])

    useEffect(() => {
        if (files != null && files.length > 0) {
            setVisible(true);
        }
    }, [files])

    return {
        files,
        visible,
        startDownload,
        startExtraDownload,
        onEnd,
    } as DownloadState
}

interface Iprops {

}
export default function DownloadPanel(props: Iprops) {

    const downloadContext = useContext<DownloadState>(DownloadContext);
    const [stopSignal, setStopSignal] = useState(false);
    const [uploadCounter, setUploadCounter] = useState(0);

    useEffect(() => {
        if (downloadContext.visible) {
            setStopSignal(false)
            let files = downloadContext.files;
            if (files == null || files.length === 0) {
                message.warning('没有要下载的文件，下载被取消');
                onClose();
                return;
            }
        }
    }, [downloadContext.visible])

    useEffect(() => {
        if (uploadCounter && uploadCounter === downloadContext.files?.length) {
            onClose(500);
        }
    }, [uploadCounter, downloadContext.files])

    const stop = () => {
        setStopSignal(true)
        onClose(0);
    }

    const onClose = (time = 1000) => {
        setTimeout(() => {
            downloadContext.onEnd();
            setUploadCounter(0);
            setStopSignal(false);
        }, time)
    }

    return (
        <DragModal
            visible={downloadContext.visible}
            mask
            showHeader={false}
            destroyOnClose={true}
        >
            <div className="download-panel-container">
                {downloadContext.files?.map((item, idx) => (
                    <DownloadItem
                        file={item}
                        key={idx}
                        stopSignal={stopSignal}
                        onComplete={() => setUploadCounter(pre => pre + 1)} />
                ))}
                <div className="footer">
                    <Button danger size="small" onClick={stop}>取消下载</Button>
                </div>
            </div>

        </DragModal>
    )
}